var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoldArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0856 7.04286L2.6089 6.55254C2.40706 6.34492 2.40706 6.00921 2.6089 5.80381L6.78106 1.5102C6.9829 1.30259 7.30929 1.30259 7.50898 1.5102L11.6811 5.8016C11.883 6.00921 11.883 6.34493 11.6811 6.55033L11.2044 7.04065C11.0005 7.25047 10.6676 7.24605 10.4679 7.03181L8.005 4.37261V10.7203C8.005 11.014 7.77524 11.2503 7.48966 11.2503H6.80253C6.51694 11.2503 6.28718 11.014 6.28718 10.7203V4.37261L3.82211 7.03402C3.62242 7.25047 3.28959 7.25489 3.0856 7.04286Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldArrow);
export default __webpack_public_path__ + "static/media/boldArrow.4a63f8fea155506fd11280f6152aca18.svg";
export { ForwardRef as ReactComponent };